'use strict';
import {SystemEvent} from "../../services/system-state/SystemEvent";

{
    var app = angular.module('tf.portfolio.widgets.whtIfChart', [])
        .controller('whatIfChartCtrl', ['$scope', '$filter', '$localStorage', '$timeout', "systemEventService",
            function whatIfChartCtrl($scope, $filter, $localStorage, $timeout, systemEventService) {

            $scope.widgetContentHeight = 270;

            $scope.$on('gridster-resized', function() {
                $scope.updateChartHeight();
            });

            $scope.$on('gridster-item-resized-stop', function(widget) {
                $scope.updateChartHeight();
            });

            $scope.$watch('gridsterItem.sizeY', function() {
                $scope.updateChartHeight();
            });

            $scope.updateChartHeight = function() {
                if($scope.gridsterItem != null) {
                    $scope.widgetContentHeight = $scope.calculateAvailableWidgetHeight($scope.gridsterItem);
                    $scope.whatIfSecurityOptions.chart.height = $scope.widgetContentHeight;
                }

                if ($scope.chartApi) {
                    $scope.chartApi.refresh();
                }
            };

            const resizeSub = systemEventService.filter(evt => evt === SystemEvent.VIEW_RESIZE)
                                                .subscribe(() => $scope.updateChartHeight());
            $scope.$on("$destroy", () => resizeSub.unsubscribe());

            $scope.whatIfSecurityOptions = {
                refreshDataOnly : true,
                chart: {
                    type: 'multiBarChart',
                    height: $scope.widgetContentHeight,
                    margin : {
                        top: 25,
                        right: 20,
                        bottom: 30,
                        left: 60
                    },
                    reduceXTicks : false,
                    multibar: {
                        dispatch: {
                            elementClick: function (event) {
                                if ($scope.activeChart === $scope.summary) {
                                    switch (event.index) {
                                        case 0:
                                            $scope.showData($scope.total);
                                            break;
                                        case 1:
                                            $scope.showData($scope.premium);
                                            break;
                                        case 2:
                                            $scope.showData($scope.span);
                                            break;
                                        case 3:
                                            $scope.showData($scope.interComm);
                                            break;
                                    }
                                } else {
                                    $scope.showData($scope.summary);
                                }
                                $scope.$apply();
                            }
                        }
                    },
                    x: function(d){return d[0];},
                    y: function(d){return d[1];},
                    //yErr: function(d){ return [-Math.abs(d.value * Math.random() * 0.3), Math.abs(d.value * Math.random() * 0.3)] },
                    showControls: false,
                    showValues: true,
                    clipEdge: true,
                    tooltip : {
                        contentGenerator: function (e) {
                            var key = e.data.key;
                            var graphType = key;

                            if ($scope.activeChart === $scope.summary) {
                                graphType = e.data[0];
                            } else if ($scope.activeChart === $scope.total) {
                                graphType = 'Total Margin' + ' ' + e.data[0];
                            } else if ($scope.activeChart === $scope.span) {
                                graphType = 'SPAN Margin' + ' ' + e.data[0];
                            } else if ($scope.activeChart === $scope.premium) {
                                graphType = 'Premium Margin' + ' ' + e.data[0];
                            } else if ($scope.activeChart === $scope.interComm) {
                                graphType = 'Inter-Commodity' + ' ' + e.data[0];
                            }

                            var tooltip = '<h3>' + graphType + '</h3>' +
                                "<table><tbody>" +
                                "<tr><td class=\"key\">" + key + "</td> <td class=\"value\">$" + $scope.numberFilter(e.data[1], 2) + "</td></tr>";

                            if (key === "Current") {
                                var change = (e.data[1] - $scope.data[0].values[e.index][1]);
                                tooltip += "<tr><td class=\"key\">Change from EOD</td> <td class=\"value " + (change < 0 ? "long" : "short") + "\">$" + $scope.numberFilter(change, 2) + "</td></tr>";
                            } else if (key === 'Strategy') {
                                var change = (e.data[1] - $scope.data[$scope.activeScenario ? 2 : 1].values[e.index][1]);
                                tooltip += "<tr><td class=\"key\">Change from " + ($scope.activeScenario ? $scope.activeScenario.name : "Current") + "</td> <td class=\"value " + (change < 0 ? "long" : "short") + "\">$" + $scope.numberFilter(change, 2) + "</td></tr>";
                            } else {
                                var change = (e.data[1] - $scope.data[1].values[e.index][1]);
                                tooltip += "<tr><td class=\"key\">Change from Current</td> <td class=\"value " + (change < 0 ? "long" : "short") + "\">$" + $scope.numberFilter(change, 2) + "</td></tr>";
                            }

                            tooltip +=
                                "</tbody></table>";

                            return tooltip;
                        }
                    },
                    duration: 1000,
                    xAxis: {
                        showMaxMin: false,
                        tickFormat: function(input) {
                            if ($scope.data != $scope.summary) {
                                return $scope.modified(input, $scope.activeScenario);
                            }

                            return input;
                        },
                        highlightZero: false
                    },
                    yAxis: {
                        tickFormat: d3.format(',.0f'),
                        highlightZero: false
                    }
                }
            };

            $scope.summary = [
                {key : "EOD", values : []},
                {key : "Current", values : []},
                {key : "Strategy", values : []}
            ];

            $scope.total = [
                {key : "EOD", values : []},
                {key : "Current", values : []},
                {key : "Strategy", values : []}
            ];

            $scope.premium = [
                {key : "EOD", values : []},
                {key : "Current", values : []},
                {key : "Strategy", values : []}
            ];

            $scope.span = [
                {key : "EOD", values : []},
                {key : "Current", values : []},
                {key : "Strategy", values : []}
            ];

            $scope.interComm = [
                {key : "EOD", values : []},
                {key : "Current", values : []},
                {key : "Strategy", values : []}
            ];

            $scope.showData = function (chart) {
                $scope.activeChart = chart;
                $scope.data.length = 0;

                chart.forEach(function (d) {
                    $scope.data.push(d);
                });

                if ($scope.chartApi) {
                    $scope.chartApi.update();
                }
            };

            $scope.data = [];
            $scope.showData($scope.summary);

            $scope.$on('margin.whatif.changed', function(event, whatIfMargin, scenarioMargin, currentMargin, eodMargin) {
                updateData(whatIfMargin, scenarioMargin, currentMargin, eodMargin);
            });
            if($scope.lastMarginWhatifChangedData && $scope.lastMarginWhatifChangedData.whatIfMargin) {
                updateData($scope.lastMarginWhatifChangedData.whatIfMargin,
                    $scope.lastMarginWhatifChangedData.scenarioMargin,
                    $scope.lastMarginWhatifChangedData.currentMargin,
                    $scope.lastMarginWhatifChangedData.eodMargin);
            }

            function updateData(whatIfMargin, scenarioMargin, currentMargin, eodMargin) {
                // var eodMultipler = $scope.$storage.portfolioClientMargin ? eodMargin.marginMultiplier : 1;
                var currentMultipler = $scope.$storage.portfolioClientMargin ? currentMargin.marginMultiplier : 1;
                // TODO EOD margin is 1 if there is a schedule in use, so copy from current as it should be close
                var eodMultipler = currentMultipler;
                var scenarioMultiplier = $scope.$storage.portfolioClientMargin && scenarioMargin ? scenarioMargin.marginMultiplier : 1;
                var whatIfMultiplier = $scope.$storage.portfolioClientMargin ? whatIfMargin.marginMultiplier : 1;

                $scope.summary.length = 0;
                $scope.summary.push({key : "EOD", values : [
                    ['Total Margin', eodMargin.totalMargin * eodMultipler],
                    ['Premium Margin', eodMargin.premiumMargin * eodMultipler],
                    ['SPAN Margin', eodMargin.spanMargin * eodMultipler],
                    ['Inter-Commodity', eodMargin.interCommodityConcession * eodMultipler]
                ]});


                $scope.summary.push({key : "Current",
                    values : [
                        ['Total Margin', currentMargin.totalMargin * currentMultipler],
                        ['Premium Margin', currentMargin.premiumMargin * currentMultipler],
                        ['SPAN Margin', currentMargin.spanMargin * currentMultipler],
                        ['Inter-Commodity', currentMargin.interCommodityConcession * currentMultipler]
                    ]});

                if ($scope.activeScenario && scenarioMargin) {
                    $scope.summary.push({key : $scope.activeScenario.name,
                        values : [
                            ['Total Margin', scenarioMargin.totalMargin * scenarioMultiplier],
                            ['Premium Margin', scenarioMargin.premiumMargin * scenarioMultiplier],
                            ['SPAN Margin', scenarioMargin.spanMargin * scenarioMultiplier],
                            ['Inter-Commodity', scenarioMargin.interCommodityConcession * scenarioMultiplier]
                        ]});
                }

                $scope.summary.push({key : "Strategy", values : [
                    ['Total Margin', whatIfMargin.totalMargin * whatIfMultiplier],
                    ['Premium Margin', whatIfMargin.premiumMargin * whatIfMultiplier],
                    ['SPAN Margin', whatIfMargin.spanMargin * whatIfMultiplier],
                    ['Inter-Commodity', whatIfMargin.interCommodityConcession * whatIfMultiplier]
                ]});

                var eodTotalMarginValues = [];
                var currentTotalMarginValues = [];
                var scenarioTotalMarginValues = [];
                var whatIfTotalMarginValues = [];

                var eodSpanMarginValues = [];
                var currentSpanMarginValues = [];
                var scenarioSpanMarginValues = [];
                var whatIfSpanMarginValues = [];

                var eodPremiumMarginValues = [];
                var currentPremiumMarginValues = [];
                var scenarioPremiumMarginValues = [];
                var whatIfPremiumMarginValues = [];

                var eodInterCommodityConcessionValues = [];
                var currentInterCommodityConcessionValues = [];
                var scenarioInterCommodityConcessionValues = [];
                var whatIfInterCommodityConcessionValues = [];

                var bySecurity = function (a, b){
                    if (a.security < b.security)
                        return -1;
                    if (a.security > b.security)
                        return 1;
                    return 0;
                };

                eodMargin.combinedCommodities.sort(bySecurity);
                currentMargin.combinedCommodities.sort(bySecurity);
                whatIfMargin.combinedCommodities.sort(bySecurity);
                if (scenarioMargin) {
                    scenarioMargin.combinedCommodities.sort(bySecurity);
                }

                for (var i = 0; i < eodMargin.combinedCommodities.length; i++) {
                    var cc = eodMargin.combinedCommodities[i];
                    eodTotalMarginValues.push([cc.security, (cc.premiumMargin + cc.scanRisk) * eodMultipler]);
                    eodSpanMarginValues.push([cc.security, cc.spanMargin * eodMultipler]);
                    eodPremiumMarginValues.push([cc.security, cc.premiumMargin * eodMultipler]);
                    eodInterCommodityConcessionValues.push([cc.security, cc.icConcession * eodMultipler]);

                }

                for (var i = 0; i < currentMargin.combinedCommodities.length; i++) {
                    var cc = currentMargin.combinedCommodities[i];
                    currentTotalMarginValues.push([cc.security, (cc.premiumMargin + cc.scanRisk) * currentMultipler]);
                    currentSpanMarginValues.push([cc.security, cc.spanMargin * currentMultipler]);
                    currentPremiumMarginValues.push([cc.security, cc.premiumMargin * currentMultipler]);
                    currentInterCommodityConcessionValues.push([cc.security, cc.icConcession * currentMultipler]);
                }

                if (scenarioMargin) {
                    for (var i = 0; i < scenarioMargin.combinedCommodities.length; i++) {
                        var cc = scenarioMargin.combinedCommodities[i];
                        scenarioTotalMarginValues.push([cc.security, (cc.premiumMargin + cc.scanRisk) * scenarioMultiplier]);
                        scenarioSpanMarginValues.push([cc.security, cc.spanMargin * scenarioMultiplier]);
                        scenarioPremiumMarginValues.push([cc.security, cc.premiumMargin * scenarioMultiplier]);
                        scenarioInterCommodityConcessionValues.push([cc.security, cc.icConcession * scenarioMultiplier]);
                    }
                }

                for (var i = 0; i < whatIfMargin.combinedCommodities.length; i++) {
                    var cc = whatIfMargin.combinedCommodities[i];
                    whatIfTotalMarginValues.push([cc.security, (cc.premiumMargin + cc.scanRisk) * whatIfMultiplier]);
                    whatIfSpanMarginValues.push([cc.security, cc.spanMargin * whatIfMultiplier]);
                    whatIfPremiumMarginValues.push([cc.security, cc.premiumMargin * whatIfMultiplier]);
                    whatIfInterCommodityConcessionValues.push([cc.security, cc.icConcession * whatIfMultiplier]);
                }


                $scope.total.length = 0;
                $scope.total.push({key : "EOD", values : eodTotalMarginValues});
                $scope.total.push({key : "Current", values : currentTotalMarginValues});
                if ($scope.activeScenario && scenarioMargin) {
                    $scope.total.push({key: $scope.activeScenario.name, values: scenarioTotalMarginValues});
                }
                $scope.total.push({key : "Strategy", values : whatIfTotalMarginValues});

                $scope.span.length = 0;
                $scope.span.push({key : "EOD", values : eodSpanMarginValues});
                $scope.span.push({key : "Current", values : currentSpanMarginValues});
                if ($scope.activeScenario && scenarioMargin) {
                    $scope.span.push({key: $scope.activeScenario.name, values: scenarioSpanMarginValues});
                }
                $scope.span.push({key : "Strategy", values : whatIfSpanMarginValues});

                $scope.premium.length = 0;
                $scope.premium.push({key : "EOD", values : eodPremiumMarginValues});
                $scope.premium.push({key : "Current", values : currentPremiumMarginValues});
                if ($scope.activeScenario && scenarioMargin) {
                    $scope.premium.push({key: $scope.activeScenario.name, values: scenarioPremiumMarginValues});
                }
                $scope.premium.push({key : "Strategy", values : whatIfPremiumMarginValues});

                $scope.interComm.length = 0;
                $scope.interComm.push({key : "EOD", values : eodInterCommodityConcessionValues});
                $scope.interComm.push({key : "Current", values : currentInterCommodityConcessionValues});
                if ($scope.activeScenario && scenarioMargin) {
                    $scope.interComm.push({key: $scope.activeScenario.name, values: scenarioInterCommodityConcessionValues});
                }
                $scope.interComm.push({key : "Strategy", values : whatIfInterCommodityConcessionValues});

                $timeout(function () {
                    $scope.showData($scope.activeChart);
                }, 100);

            }
        }]);
}
